import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "dot", "container"]

  connect() {
    this.currentIndex = 0
    this.startAutoAdvance()

    this.containerTarget.addEventListener("mouseenter", this.pause)
    this.containerTarget.addEventListener("mouseleave", this.resume)
  }

  disconnect() {
    this.stopAutoAdvance()
    this.containerTarget.removeEventListener("mouseenter", this.pause)
    this.containerTarget.removeEventListener("mouseleave", this.resume)
  }

  next() {
    const nextIndex = (this.currentIndex + 1) % this.slideTargets.length
    this.showSlide(nextIndex)
    this.restartAutoAdvance()
  }

  prev() {
    const prevIndex = (this.currentIndex - 1 + this.slideTargets.length) % this.slideTargets.length
    this.showSlide(prevIndex)
    this.restartAutoAdvance()
  }

  goTo(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10)
    this.showSlide(index)
    this.restartAutoAdvance()
  }

  showSlide(index) {
    this.slideTargets.forEach((slide, i) => {
      if (i === index) {
        slide.classList.remove("testimonial-slide-hidden")
        slide.classList.add("testimonial-slide-active")
      } else {
        slide.classList.remove("testimonial-slide-active")
        slide.classList.add("testimonial-slide-hidden")
      }
    })

    this.dotTargets.forEach((dot, i) => {
      if (i === index) {
        dot.classList.add("bg-[#c70078]")
        dot.classList.remove("bg-foreground/20")
      } else {
        dot.classList.remove("bg-[#c70078]")
        dot.classList.add("bg-foreground/20")
      }
    })

    this.currentIndex = index
  }

  startAutoAdvance() {
    this.timer = setInterval(() => this.next(), 8000)
  }

  stopAutoAdvance() {
    if (this.timer) clearInterval(this.timer)
  }

  restartAutoAdvance() {
    this.stopAutoAdvance()
    this.startAutoAdvance()
  }

  pause = () => this.stopAutoAdvance()
  resume = () => this.startAutoAdvance()
}
